import React, { useEffect, useState } from "react";
import { dialogStore } from "../../../utils/dialog";
import ConfirmDialog from "./ConfirmDialog";
import PromptDialog from "./PromptDialog";

/** Mount once (App.js). Renders whichever dialog the app asked for via utils/dialog. */
export default function DialogHost() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    window.__eeDialogHostMounted = true;
    const off = dialogStore.subscribe(setItems);
    return () => {
      window.__eeDialogHostMounted = false;
      off();
    };
  }, []);

  const top = items[0];
  if (!top) return null;
  const { id, kind, spec } = top;

  if (kind === "prompt") {
    return (
      <PromptDialog
        open
        {...spec}
        onSubmit={(values) => dialogStore.resolve(id, values)}
        onCancel={() => dialogStore.resolve(id, null)}
      />
    );
  }

  if (kind === "alert") {
    return (
      <ConfirmDialog
        open
        tone={spec.tone || "primary"}
        title={spec.title}
        message={spec.message}
        confirmLabel={spec.confirmLabel || "OK"}
        hideCancel
        confirmVariant="primary"
        onConfirm={() => dialogStore.resolve(id)}
        onCancel={() => dialogStore.resolve(id)}
      />
    );
  }

  return (
    <ConfirmDialog
      open
      {...spec}
      onConfirm={() => dialogStore.resolve(id, true)}
      onCancel={() => dialogStore.resolve(id, false)}
    />
  );
}
